export default function () {
  return {
    login: {},
    isLogged: false,
  };
}
